import { Grid2 as Grid, styled } from '@mui/material';
import { EmployeeLinkField } from 'domain/shared/employee';
import { TextField, DurationBetweenTwoDatesIconField } from 'framework/ui/field';
import BenchAssignField from './shared/fields/BenchAssignField';

const StyledGrid = styled(Grid)(() => ({
  fontSize: '12px',
  '.MuiTypography-root': {
    fontSize: '12px',
  },
  '.field__wrapper > .MuiTypography-root': {
    fontSize: '12px',
  },
}));

// TODO Add AdditionalText and Edit / Employee Status
const BenchListItem = () => {
  return (
    <Grid container width="100%" columns={12} spacing={1} justifyContent="space-between" alignItems="center">
      <StyledGrid size={{ xs: 3 }}>
        <EmployeeLinkField nameSource="employeeName" source="employeeAlias" label="" />
      </StyledGrid>

      <StyledGrid size={{ xs: 2 }}>
        <TextField source="employeeSpecialization" label="" />
      </StyledGrid>

      <StyledGrid size={{ xs: 2 }}>
        <BenchAssignField />
      </StyledGrid>

      <StyledGrid size={{ xs: 3 }}>
        <TextField source="benchProject" label="" />
      </StyledGrid>

      <StyledGrid size={{ xs: 2 }}>
        <DurationBetweenTwoDatesIconField dateFromSource="dudationStart" />
      </StyledGrid>

      {/* <StyledGrid size={{ xs: 3 }}>
        <TextField source="additionalText" label="" />
      </StyledGrid> */}

      {/* <StyledGrid size={{ xs: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton>
            <AppRegistrationIcon color="primary" />
          </IconButton>
        </Box>
      </StyledGrid> */}
    </Grid>
  );
};

export default BenchListItem;
